module.exports = __webpack_public_path__ + "img/5.35f715e2.jpg";